import { getAuthorCart } from './AuthorCart';

export const CHECKOUT_API = process.env.REACT_APP_STRIPE_LAMBDA_URL || process.env.REACT_APP_CHECKOUT_SESSION_URL || 'https://b7zlmugmb8.execute-api.us-west-2.amazonaws.com/default/createCheckoutSession';
const prefix = 'bookish-checkout-return:';
const validSession = id => /^cs_(test|live)_[A-Za-z0-9]{16,256}$/.test(id || '');
const fingerprint = item => JSON.stringify([item.bookSlug || '', item.format || '', item.variationName || '', Number(item.price), item.cartRevision || '']);

export function rememberCheckout(data, items, cartCheckout) {
  if (!validSession(data.sessionId) || !/^[A-Za-z0-9_-]{43}$/.test(data.verificationToken || '')) throw new Error('Checkout could not be prepared securely. Please try again.');
  const snapshot = items.map(({cartItemId, bookSlug, format, variationName, price, quantity, cartRevision}) => ({cartItemId, bookSlug, format, variationName, price, quantity, cartRevision}));
  try { sessionStorage.setItem(prefix + data.sessionId, JSON.stringify({ token: data.verificationToken, items: snapshot, cartCheckout, createdAt:Date.now() })); }
  catch { throw new Error('Your browser could not save the checkout reference. Please allow browser storage and try again.'); }
}

function reconcileCart(sessionId, snapshot) {
  if (!snapshot.cartCheckout) return 'unchanged';
  const marker = prefix + 'applied:' + sessionId;
  const previous = localStorage.getItem(marker);
  if (previous) return previous === 'done' ? 'updated' : 'review';
  if (!Number.isFinite(snapshot.createdAt) || Date.now() - snapshot.createdAt > 86400000) return 'review';
  // Write ahead: an interrupted update must never subtract a purchase twice.
  localStorage.setItem(marker, 'started');
  const quantities = new Map(snapshot.items.map(item => [item.cartItemId, item]));
  const next = getAuthorCart().flatMap(item => {
    const purchased = quantities.get(item.cartItemId);
    if (!purchased || fingerprint(item) !== fingerprint(purchased)) return [item];
    const count = Number(purchased.quantity);
    if (!Number.isSafeInteger(count) || count < 1) return [item];
    const remaining = Number(item.quantity || 1) - count;
    return remaining > 0 ? [{...item, quantity: remaining}] : [];
  });
  localStorage.setItem(`bookish-author-cart:${window.location.hostname.toLowerCase()}`, JSON.stringify(next));
  localStorage.setItem(marker, 'done');
  window.dispatchEvent(new CustomEvent('bookish-cart-updated', {detail: {items: next}}));
  return 'updated';
}

export async function verifyCheckoutReturn(sessionId, signal) {
  if (!validSession(sessionId)) return {status:'unavailable'};
  let snapshot;
  try { snapshot = JSON.parse(sessionStorage.getItem(prefix + sessionId)); } catch { return {status:'unavailable'}; }
  if (!snapshot?.token || !Array.isArray(snapshot.items)) return {status:'unavailable'};
  const response = await fetch(CHECKOUT_API, {method:'POST', signal, headers:{'Content-Type':'application/json'}, body:JSON.stringify({action:'verify-checkout',sessionId,verificationToken:snapshot.token})});
  if (!response.ok) throw new Error('We couldn’t verify payment right now. Your cart has been kept. Please try again.');
  const result = await response.json();
  if (signal?.aborted) return {status:'unavailable'};
  if (result.confirmed !== true) return {status: result.expired === true ? 'expired' : 'pending'};
  let cart = 'review';
  try { cart = reconcileCart(sessionId, snapshot); } catch { /* Payment remains confirmed if cart storage fails. */ }
  return {status:'confirmed',cart};
}
